import firebase from 'firebase' 

const firebaseConfig = {
    apiKey: "AIzaSyDwPa_KBniL-LLdDdQkUXWW81xJFpkqMzc",
    authDomain: "neary-somrosthomcheat.firebaseapp.com",
    projectId: "neary-somrosthomcheat",
    storageBucket: "neary-somrosthomcheat.appspot.com",
    messagingSenderId: "1017083083214",
    appId: "1:1017083083214:web:3930fcfda8788b3186d39f",
    measurementId: "G-3971LWVTTX"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();
//require("firebase/firestore");

export const db = firebase.firestore();